window.KombiApp = window.KombiApp || { };
window.KombiApp.UrlHelpers = {
    updateQueryStringParam: function updateQueryStringParam(key, value) {
        var url = KombiApp.UrlHelpers.getUrlWithQueryStringParam(window.location.href, key, value);
        history.replaceState(null, null, url.toString());
    },

    getUrlWithQueryStringParam: function getUrlWithQueryStringParam(url, paramKey, paramValue) {
        var url = new URL(window.location.href);
        var searchParams = new URLSearchParams(url.search);
        if (paramValue == null) {
            searchParams.delete(paramKey);
            url.search = searchParams.toString();
        }
        else {
            searchParams.set(paramKey, paramValue);
            url.search = searchParams.toString();
        }
        return url.toString();
    },
    
    getQueryStringParam: function(key) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    }
}